import { ChangeDetectionStrategy, Component, EventEmitter, inject, Output } from '@angular/core';
import { MDBBootstrapModulesPro, MDBModalRef } from 'ng-uikit-pro-standard';
import { BaryComponentHelper } from '../../../../util/bary-component-helper';
import { IBaryModalEvent } from '../../../../../../models/bary-modal-event';
import { TranslateDirective } from '../../../../../../directives/translate.directive';
import { BaryIconComponent } from '../../../bary-icon/bary-icon.component';
import { FaDirectiveEnum } from '../../../../../../models/enums/fa-directive.enum';

@Component({
  selector: 'jhi-bary-modal-cut-off-how-to',
  templateUrl: './bary-modal-cut-off-how-to.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateDirective, MDBBootstrapModulesPro, BaryIconComponent],
})
export class BaryModalCutOffHowToComponent {
  readonly modalRef = inject(MDBModalRef);

  public action = BaryComponentHelper.generateAction<IBaryModalEvent>();

  protected readonly FAS = FaDirectiveEnum.FAS;

  @Output() closeEvent = new EventEmitter();

  public handleClick(): void {
    this.modalRef.hide();
  }
}
